import { LogNotification, LogNotifyPayment } from '@/api';

type ActiveBroadcastContext = {
    routeBroadcastId?: string;
    gameId?: string;
    broadcasterId?: string;
    currentUserId?: string;
    donationsEnabled: boolean;
};

export const shouldSilenceDonationNotification = (notification: LogNotification, context: ActiveBroadcastContext) =>
    notification.payment === LogNotifyPayment.NOTIFY_PAYMENT_DONATION &&
    !!context.routeBroadcastId &&
    context.routeBroadcastId === context.gameId &&
    context.broadcasterId === context.currentUserId &&
    context.donationsEnabled;
